// This is a fork of Box using performant styled-components
import React, { forwardRef } from "react";
import styled from "styled-components";
import { node, bool, string, elementType, oneOfType } from "prop-types";
import {
  borders,
  compose,
  display,
  flexbox,
  palette,
  positions,
  shadows,
  sizing,
  spacing,
  typography,
} from "@material-ui/system";
import { omit } from "ramda";

const BaseBox = forwardRef(
  (
    { clone, component: Component = "div", children, className, ...props },
    ref
  ) => {
    const boxProps = omit(styleFunction.filterProps, props);
    return clone ? (
      React.cloneElement(children, { className })
    ) : (
      <Component className={className} {...boxProps} ref={ref}>
        {children}
      </Component>
    );
  }
);

const styleFunction = compose(
  borders,
  display,
  flexbox,
  palette,
  positions,
  shadows,
  sizing,
  spacing,
  typography
);

const Box = styled(BaseBox)`
  ${styleFunction}
`;

BaseBox.propTypes = {
  clone: bool,
  component: oneOfType([string, elementType]),
  children: node,
  ...styleFunction.propTypes,
};

export default Box;
